import React from "react";
import { objectTypes } from "../../../core/components/buttonpanel/interface/Ibuttons";


interface IframeworkCanvasAutoplay {
    data: {}

}

export const frameworkCanvasAutoplay: IframeworkCanvasAutoplay = {

    data: {
        "COMPONENTS": [
            {
                "name": "autoplay_graphic",
                "type": "Graphic",
                "shape": "rectangle",
                "visible": true,
                "alpha": 0.92,
                "color": "0x000000",
                "x": 0,
                "y": -58,
                "width": 1920,
                "height": 1080,

            },
            {
                "name": "desk_autoplay_base",
                "image": "desk_autoplay_base.png",
                "type": "Image",
                "class": "",
                "layout": false,
                "uimode": "desktop",
                "visible": true,
                "width": 250,
                "height": 470,
                "anchor": [0, 0],
                "x": 1526,
                "y": 445,
            },

            {
                "id": "autoplayHeading",
                "name": "autoplayHeading",
                "type": "Text",
                "x": 1653,
                "y": 480,
                "width": 500,
                "visible": true,
                "text": "autoplayText_25",
                "scaleToFit": true,
                "anchor": [0.5, 0.5],
                "textStyle": {
                    fontFamily: 'Oswald-Light',
                    fontSize: 26,
                    fontStyle: 'normal',
                    fill: '#ffffff',
                },
            },
            {
                "id": "autoplayButton1",
                "name": "autoplayButton1",
                "type": objectTypes.Sprite,
                "interactive": false,
                "x": 1653,
                "y": 536,
                "width": 107,
                "height": 50,
                "text": "5",
                "textStyle": {
                    fontFamily: 'Oswald-Light',
                    fontSize: 24,
                    fontStyle: 'normal',

                    fill: ['#ffffff'],
                },
                "anchor": [0.5, 0.5],
                "visible": true,
                "buttonMode": true,
                "buttonState": {
                    up: 'autoplay_btn_up.png',
                    out: 'autoplay_btn_up.png',
                    down: 'autoplay_btn_over.png',
                    disable: 'autoplay_btn_up.png',
                    enable: 'autoplay_btn_up.png',
                    hover: 'autoplay_btn_up.png'
                },
                "hitareaVisible": false,
                "shapeVisible": false,
                "shape": {}
            },
            {
                "id": "autoplayButton2",
                "name": "autoplayButton2",
                "type": objectTypes.Sprite,
                "interactive": false,
                "x": 1653,
                "y": 606,
                "width": 107,
                "height": 50,
                "text": "10",
                "textStyle": {
                    fontFamily: 'Oswald-Light',
                    fontSize: 24,
                    fontStyle: 'normal',

                    fill: ['#ffffff'],
                },
                "anchor": [0.5, 0.5],
                "visible": true,
                "buttonMode": true,
                "buttonState": {
                    up: 'autoplay_btn_up.png',
                    out: 'autoplay_btn_up.png',
                    down: 'autoplay_btn_over.png',
                    disable: 'autoplay_btn_up.png',
                    enable: 'autoplay_btn_up.png',
                    hover: 'autoplay_btn_up.png'
                },
                "hitareaVisible": false,
                "shapeVisible": false,
                "shape": {}
            },
            {
                "id": "autoplayButton3",
                "name": "autoplayButton3",
                "type": objectTypes.Sprite,
                "interactive": true,
                "x": 1653,
                "y": 676,
                "width": 107,
                "height": 50,
                "text": "15",
                "textStyle": {
                    fontFamily: 'Oswald-Light',
                    fontSize: 24,
                    fontStyle: 'normal',

                    fill: ['#ffffff'],
                },
                "anchor": [0.5, 0.5],
                "visible": true,
                "buttonMode": true,
                "buttonState": {
                    up: 'autoplay_btn_up.png',
                    out: 'autoplay_btn_up.png',
                    down: 'autoplay_btn_over.png',
                    disable: 'autoplay_btn_up.png',
                    enable: 'autoplay_btn_up.png',
                    hover: 'autoplay_btn_up.png'
                },
                "hitareaVisible": false,
                "shapeVisible": false,
                "shape": {}
            },
            {
                "id": "autoplayButton4",
                "name": "autoplayButton4",
                "type": objectTypes.Sprite,
                "interactive": true,
                "x": 1653,
                "y": 746,
                "width": 107,
                "height": 50,
                "text": "20",
                "textStyle": {
                    fontFamily: 'Oswald-Light',
                    fontSize: 24,
                    fontStyle: 'normal',

                    fill: ['#ffffff'],
                },
                "anchor": [0.5, 0.5],
                "visible": true,
                "buttonMode": true,
                "buttonState": {
                    up: 'autoplay_btn_up.png',
                    out: 'autoplay_btn_up.png',
                    down: 'autoplay_btn_over.png',
                    disable: 'autoplay_btn_up.png',
                    enable: 'autoplay_btn_up.png',
                    hover: 'autoplay_btn_up.png'
                },
                "hitareaVisible": false,
                "shapeVisible": false,
                "shape": {}
            },
            {
                "id": "autoplayButton5",
                "name": "autoplayButton5",
                "type": objectTypes.Sprite,
                "interactive": true,
                "x": 1653,
                "y": 816,
                "width": 107,
                "height": 50,
                "text": "30",
                "textStyle": {
                    fontFamily: 'Oswald-Light',
                    fontSize: 24,
                    fontStyle: 'normal',

                    fill: ['#ffffff'],
                },
                "anchor": [0.5, 0.5],
                "visible": true,
                "buttonMode": true,
                "buttonState": {
                    up: 'autoplay_btn_up.png',
                    out: 'autoplay_btn_up.png',
                    down: 'autoplay_btn_over.png',
                    disable: 'autoplay_btn_up.png',
                    enable: 'autoplay_btn_up.png',
                    hover: 'autoplay_btn_up.png'
                },
                "hitareaVisible": false,
                "shapeVisible": false,
                "shape": {}
            },

            /*   {
                  "id": "lossLimit__Container",
                  "name": "lossLimit__Container",
                  "type": "Container",
                  "x": 0,
                  "y": 0,
                  "visible": true,
                  child: [
                      {
                          "name": "autoplay_value_frame_losslimit",
                          "image": "autoplay_value_frame.png",
                          "type": "Image",
                          "class": "",
                          "layout": false,
                          "uimode": "desktop",
                          "visible": true,
                          "width": 878,
                          "height": 139,
                          "anchor": [0, 0],
                          "x": 495,
                          "y": 250,
                      },
  
  
                      {
                          "id": "loss_limit_label",
                          "name": "autoplay_losslimitlbl",
                          "type": "Text",
                          "x": 600,
                          "y": 270,
                          "width": 300,
                          "visible": true,
                          "uiMode": "desktop",
                          "layout": false,
                          "text": "LossLimit_txt",
                          "scaleToFit": true,
                          "anchor": [1, 0],
                          "textStyle": {
                              fontFamily: 'Oswald-Light',
                              fontSize: 22,
                              fontStyle: 'normal',
                              fill: ['#848484'],
                          },
                      },
  
                      {
                          "name": "generateBoxFrame",
                          "image": "value_txt_frame.png",
                          "type": "Image",
                          "class": "",
                          "layout": false,
                          "uimode": "desktop",
                          "visible": true,
                          "width": 151,
                          "height": 41,
                          "anchor": [0, 0],
                          "x": 620,
                          "y": 265,
                      },
                      {
                          "name": "valueFramelosslimit",
                          "image": "value_txt_frame.png",
                          "type": "Image",
  
                          "class": "",
                          "layout": false,
                          "uimode": "desktop",
                          "visible": true,
                          "width": 151,
                          "height": 41,
                          "anchor": [0, 0],
                          "x": 620,
                          "y": 265,
                      },
  
                      {
                          "name": "inputBox_1",
                          "type": "Graphic",
                          "shape": "rectangle",
                          "uiMode": "desktop",
                          "layout": false,
                          "visible": true,
                          "buttonMode": true,
                          "interactive": false,
                          "alpha": 0.1,
                          "color": "0x131313",
                          "x": 620,
                          "y": 265,
                          "width": 151,
                          "height": 41,
  
                      },
  
                      {
                          "id": "sliderDot_inputBoxText",
                          "name": "sliderDot_inputBoxText",
                          "type": "Text",
                          "uiMode": "desktop",
                          "layout": false,
                          "x": 693,
                          "y": 287,
                          "width": 151,
                          "height": 41,
                          "visible": true,
                          "text": "",
                          "scaleToFit": true,
                          "anchor": [0.5, 0.5],
                          "textStyle": {
                              fontFamily: 'Oswald-Light',
                              fontSize: 24,
  
                              fill: '#ffffff',
                          },
                      },
  
  
                      {
                          "id": "LossLimitBtn1",
                          "name": "LossLimitBtn1",
                          "type": objectTypes.Sprite,
                          "interactive": false,
                          "uiMode": "desktop",
                          "layout": false,
                          "x": 650,
                          "y": 340,
                          "width": 107,
                          "height": 50,
                          "text": "option1",
                          "scaleToFit": true,
                          "textStyle": {
                              fontFamily: 'Oswald-Light',
                              fontSize: 24,
                              fontStyle: 'normal',
  
                              fill: ['#ffffff'],
                          },
                          "anchor": [0.5, 0.5],
                          "visible": true,
                          "buttonMode": true,
                          "buttonState": {
                              up: 'autoplay_btn_up.png',
                              out: 'autoplay_btn_up.png',
                              down: 'autoplay_btn_up.png',
                              disable: 'autoplay_btn_up.png',
                              enable: 'autoplay_btn_up.png',
                              hover: 'autoplay_btn_up.png'
                          },
                          "hitareaVisible": false,
                          "shapeVisible": false,
                          "shape": {}
                      },
                      {
                          "id": "LossLimitBtn2",
                          "name": "LossLimitBtn2",
                          "type": objectTypes.Sprite,
                          "interactive": false,
                          "uiMode": "desktop",
                          "layout": false,
                          "x": 800,
                          "y": 340,
                          "width": 107,
                          "height": 50,
                          "text": "option2",
                          "scaleToFit": true,
                          "textStyle": {
                              fontFamily: 'Oswald-Light',
                              fontSize: 24,
                              fontStyle: 'normal',
  
                              fill: ['#ffffff'],
                          },
                          "anchor": [0.5, 0.5],
                          "visible": true,
                          "buttonMode": true,
                          "buttonState": {
                              up: 'autoplay_btn_up.png',
                              out: 'autoplay_btn_up.png',
                              down: 'autoplay_btn_up.png',
                              disable: 'autoplay_btn_up.png',
                              enable: 'autoplay_btn_up.png',
                              hover: 'autoplay_btn_up.png'
                          },
                          "hitareaVisible": false,
                          "shapeVisible": false,
                          "shape": {}
                      },
                      {
                          "id": "LossLimitBtn3",
                          "name": "LossLimitBtn3",
                          "type": objectTypes.Sprite,
                          "interactive": true,
                          "uiMode": "desktop",
                          "layout": false,
                          "x": 950,
                          "y": 340,
                          "width": 107,
                          "height": 50,
                          "text": "option3",
                          "scaleToFit": true,
                          "textStyle": {
                              fontFamily: 'Oswald-Light',
                              fontSize: 24,
                              fontStyle: 'normal',
  
                              fill: ['#ffffff'],
                          },
                          "anchor": [0.5, 0.5],
                          "visible": true,
                          "buttonMode": true,
                          "buttonState": {
                              up: 'autoplay_btn_up.png',
                              out: 'autoplay_btn_up.png',
                              down: 'autoplay_btn_up.png',
                              disable: 'autoplay_btn_up.png',
                              enable: 'autoplay_btn_up.png',
                              hover: 'autoplay_btn_up.png'
                          },
                          "hitareaVisible": false,
                          "shapeVisible": false,
                          "shape": {}
                      },
                      {
                          "id": "LossLimitBtn4",
                          "name": "LossLimitBtn4",
                          "type": objectTypes.Sprite,
                          "interactive": true,
                          "uiMode": "desktop",
                          "layout": false,
                          "x": 1100,
                          "y": 340,
                          "width": 107,
                          "height": 50,
                          "text": "option4",
                          "scaleToFit": true,
                          "textStyle": {
                              fontFamily: 'Oswald-Light',
                              fontSize: 24,
                              fontStyle: 'normal',
  
                              fill: ['#ffffff'],
                          },
                          "anchor": [0.5, 0.5],
                          "visible": true,
                          "buttonMode": true,
                          "buttonState": {
                              up: 'autoplay_btn_up.png',
                              out: 'autoplay_btn_up.png',
                              down: 'autoplay_btn_up.png',
                              disable: 'autoplay_btn_up.png',
                              enable: 'autoplay_btn_up.png',
                              hover: 'autoplay_btn_up.png'
                          },
                          "hitareaVisible": false,
                          "shapeVisible": false,
                          "shape": {}
                      },
                      {
                          "id": "LossLimitBtn5",
                          "name": "LossLimitBtn5",
                          "type": objectTypes.Sprite,
                          "interactive": true,
                          "layout": false,
                          "uiMode": "desktop",
                          "x": 1250,
                          "y": 340,
                          "width": 107,
                          "height": 50,
                          "text": "option5",
                          "scaleToFit": true,
                          "textStyle": {
                              fontFamily: 'Oswald-Light',
                              fontSize: 24,
                              fontStyle: 'normal',
  
                              fill: ['#ffffff'],
                          },
                          "anchor": [0.5, 0.5],
                          "visible": true,
                          "buttonMode": true,
                          "buttonState": {
                              up: 'autoplay_btn_up.png',
                              out: 'autoplay_btn_up.png',
                              down: 'autoplay_btn_up.png',
                              disable: 'autoplay_btn_up.png',
                              enable: 'autoplay_btn_up.png',
                              hover: 'autoplay_btn_up.png'
                          },
                          "hitareaVisible": false,
                          "shapeVisible": false,
                          "shape": {}
                      },
                  ]
              },
   */
            /*    {
                   "id": "winLimit__Container",
                   "name": "winLimit__Container",
                   "type": "Container",
                   "x": 0,
                   "y": 170,
                   "visible": true,
                   child: [
                       {
                           "name": "autoplay_value_frame_winlimit",
                           "image": "autoplay_value_frame.png",
                           "type": "Image",
                           "class": "",
                           "layout": false,
                           "uimode": "desktop",
                           "visible": true,
                           "width": 878,
                           "height": 139,
                           "anchor": [0, 0],
                           "x": 495,
                           "y": 250,
                       },
   
   
                       {
                           "id": "loss_limit_label",
                           "name": "autoplay_winLimitlbl",
                           "type": "Text",
                           "uiMode": "desktop",
                           "layout": false,
                           "x": 600,
                           "y": 270,
                           "width": 300,
                           "visible": true,
                           "text": "winLimit_txt",
                           "scaleToFit": true,
                           "anchor": [1, 0],
                           "textStyle": {
                               fontFamily: 'Oswald-Light',
                               fontSize: 22,
                               fontStyle: 'normal',
                               fill: ['#848484'],
                           },
                       },
   
                       {
                           "name": "valueFramewinLimit",
                           "image": "value_txt_frame.png",
                           "type": "Image",
                           "class": "",
                           "layout": false,
                           "uimode": "desktop",
                           "visible": true,
                           "width": 151,
                           "height": 41,
                           "anchor": [0, 0],
                           "x": 620,
                           "y": 265,
                       },
   
                       {
                           "name": "inputBox_2",
                           "type": "Graphic",
                           "shape": "rectangle",
                           "uiMode": "desktop",
                           "layout": false,
                           "visible": true,
                           "buttonMode": true,
                           "interactive": false,
                           "alpha": 0.1,
                           "color": "0x131313",
                           "x": 620,
                           "y": 265,
                           "width": 151,
                           "height": 41,
   
                       },
   
                       {
                           "id": "sliderDot_2_inputBoxText",
                           "name": "sliderDot_2_inputBoxText",
                           "type": "Text",
                           "uiMode": "desktop",
                           "layout": false,
                           "x": 693,
                           "y": 287,
                           "width": 151,
                           "height": 41,
                           "visible": true,
                           "text": "",
                           "scaleToFit": true,
                           "anchor": [0.5, 0.5],
                           "textStyle": {
                               fontFamily: 'Oswald-Light',
                               fontSize: 24,
   
                               fill: '#ffffff',
                           },
                       },
   
                       {
                           "id": "winLimitBtn1",
                           "name": "winLimitBtn1",
                           "type": objectTypes.Sprite,
                           "interactive": false,
                           "uiMode": "desktop",
                           "layout": false,
                           "x": 650,
                           "y": 340,
                           "width": 107,
                           "height": 50,
                           "text": "option1",
                           "scaleToFit": true,
                           "textStyle": {
                               fontFamily: 'Oswald-Light',
                               fontSize: 24,
                               fontStyle: 'normal',
   
                               fill: ['#ffffff'],
                           },
                           "anchor": [0.5, 0.5],
                           "visible": true,
                           "buttonMode": true,
                           "buttonState": {
                               up: 'autoplay_btn_up.png',
                               out: 'autoplay_btn_up.png',
                               down: 'autoplay_btn_up.png',
                               disable: 'autoplay_btn_up.png',
                               enable: 'autoplay_btn_up.png',
                               hover: 'autoplay_btn_up.png'
                           },
                           "hitareaVisible": false,
                           "shapeVisible": false,
                           "shape": {}
                       },
                       {
                           "id": "winLimitBtn2",
                           "name": "winLimitBtn2",
                           "type": objectTypes.Sprite,
                           "interactive": false,
                           "uiMode": "desktop",
                           "layout": false,
                           "x": 800,
                           "y": 340,
                           "width": 107,
                           "height": 50,
                           "text": "option2",
                           "scaleToFit": true,
                           "textStyle": {
                               fontFamily: 'Oswald-Light',
                               fontSize: 24,
                               fontStyle: 'normal',
   
                               fill: ['#ffffff'],
                           },
                           "anchor": [0.5, 0.5],
                           "visible": true,
                           "buttonMode": true,
                           "buttonState": {
                               up: 'autoplay_btn_up.png',
                               out: 'autoplay_btn_up.png',
                               down: 'autoplay_btn_up.png',
                               disable: 'autoplay_btn_up.png',
                               enable: 'autoplay_btn_up.png',
                               hover: 'autoplay_btn_up.png'
                           },
                           "hitareaVisible": false,
                           "shapeVisible": false,
                           "shape": {}
                       },
                       {
                           "id": "winLimitBtn3",
                           "name": "winLimitBtn3",
                           "type": objectTypes.Sprite,
                           "interactive": true,
                           "uiMode": "desktop",
                           "layout": false,
                           "x": 950,
                           "y": 340,
                           "width": 107,
                           "height": 50,
                           "text": "option3",
                           "scaleToFit": true,
                           "textStyle": {
                               fontFamily: 'Oswald-Light',
                               fontSize: 24,
                               fontStyle: 'normal',
   
                               fill: ['#ffffff'],
                           },
                           "anchor": [0.5, 0.5],
                           "visible": true,
                           "buttonMode": true,
                           "buttonState": {
                               up: 'autoplay_btn_up.png',
                               out: 'autoplay_btn_up.png',
                               down: 'autoplay_btn_up.png',
                               disable: 'autoplay_btn_up.png',
                               enable: 'autoplay_btn_up.png',
                               hover: 'autoplay_btn_up.png'
                           },
                           "hitareaVisible": false,
                           "shapeVisible": false,
                           "shape": {}
                       },
                       {
                           "id": "winLimitBtn4",
                           "name": "winLimitBtn4",
                           "type": objectTypes.Sprite,
                           "interactive": true,
                           "uiMode": "desktop",
                           "layout": false,
                           "x": 1100,
                           "y": 340,
                           "width": 107,
                           "height": 50,
                           "text": "option4",
                           "scaleToFit": true,
                           "textStyle": {
                               fontFamily: 'Oswald-Light',
                               fontSize: 24,
                               fontStyle: 'normal',
   
                               fill: ['#ffffff'],
                           },
                           "anchor": [0.5, 0.5],
                           "visible": true,
                           "buttonMode": true,
                           "buttonState": {
                               up: 'autoplay_btn_up.png',
                               out: 'autoplay_btn_up.png',
                               down: 'autoplay_btn_up.png',
                               disable: 'autoplay_btn_up.png',
                               enable: 'autoplay_btn_up.png',
                               hover: 'autoplay_btn_up.png'
                           },
                           "hitareaVisible": false,
                           "shapeVisible": false,
                           "shape": {}
                       },
                       {
                           "id": "winLimitBtn5",
                           "name": "winLimitBtn5",
                           "type": objectTypes.Sprite,
                           "interactive": true,
                           "uiMode": "desktop",
                           "layout": false,
                           "x": 1250,
                           "y": 340,
                           "width": 107,
                           "height": 50,
                           "text": "option5",
                           "scaleToFit": true,
                           "textStyle": {
                               fontFamily: 'Oswald-Light',
                               fontSize: 24,
                               fontStyle: 'normal',
   
                               fill: ['#ffffff'],
                           },
                           "anchor": [0.5, 0.5],
                           "visible": true,
                           "buttonMode": true,
                           "buttonState": {
                               up: 'autoplay_btn_up.png',
                               out: 'autoplay_btn_up.png',
                               down: 'autoplay_btn_up.png',
                               disable: 'autoplay_btn_up.png',
                               enable: 'autoplay_btn_up.png',
                               hover: 'autoplay_btn_up.png'
                           },
                           "hitareaVisible": false,
                           "shapeVisible": false,
                           "shape": {}
                       },
                   ]
               },
   
               {
                   "id": "singleWinLimit__Container",
                   "name": "singleWinLimit__Container",
                   "type": "Container",
                   "x": 0,
                   "y": 340,
                   "visible": true,
                   child: [
                       {
                           "name": "autoplay_value_frame_singlewinlimit",
                           "image": "autoplay_value_frame.png",
                           "type": "Image",
                           "class": "",
                           "layout": false,
                           "uimode": "desktop",
                           "visible": true,
                           "width": 878,
                           "height": 139,
                           "anchor": [0, 0],
                           "x": 495,
                           "y": 250,
                       },
   
   
                       {
                           "id": "loss_limit_label",
                           "name": "autoplay_singleWinLimitlbl",
                           "type": "Text",
                           "uiMode": "desktop",
                           "layout": false,
                           "x": 620,
                           "y": 270,
                           "width": 300,
                           "visible": true,
                           "text": "singleWinLimit_txt",
                           "scaleToFit": true,
                           "anchor": [1, 0],
                           "textStyle": {
                               fontFamily: 'Oswald-Light',
                               fontSize: 22,
                               fontStyle: 'normal',
                               fill: ['#848484'],
                           },
                       },
   
                       {
                           "name": "valueFramesingleWinLimit",
                           "image": "value_txt_frame.png",
                           "type": "Image",
                           "class": "",
                           "layout": false,
                           "uimode": "desktop",
                           "visible": true,
                           "width": 151,
                           "height": 41,
                           "anchor": [0, 0],
                           "x": 650,
                           "y": 265,
                       },
                       {
                           "name": "inputBox_3",
                           "type": "Graphic",
                           "shape": "rectangle",
                           "visible": true,
                           "buttonMode": true,
                           "interactive": false,
                           "alpha": 0.1,
                           "color": "0x131313",
                           "x": 650,
                           "y": 265,
                           "width": 151,
                           "height": 41,
   
                       },
   
                       {
                           "id": "sliderDot_3_inputBoxText",
                           "name": "sliderDot_3_inputBoxText",
                           "type": "Text",
                           "uiMode": "desktop",
                           "layout": false,
                           "x": 693,
                           "y": 287,
                           "width": 151,
                           "height": 41,
                           "visible": true,
                           "text": "",
                           "scaleToFit": true,
                           "anchor": [0.5, 0.5],
                           "textStyle": {
                               fontFamily: 'Oswald-Light',
                               fontSize: 24,
   
                               fill: '#ffffff',
                           },
                       },
                       {
                           "id": "singleWinLimitBtn1",
                           "name": "singleWinLimitBtn1",
                           "type": objectTypes.Sprite,
                           "interactive": false,
                           "uiMode": "desktop",
                           "layout": false,
                           "x": 650,
                           "y": 340,
                           "width": 107,
                           "height": 50,
                           "text": "option1",
                           "scaleToFit": true,
                           "textStyle": {
                               fontFamily: 'Oswald-Light',
                               fontSize: 24,
                               fontStyle: 'normal',
   
                               fill: ['#ffffff'],
                           },
                           "anchor": [0.5, 0.5],
                           "visible": true,
                           "buttonMode": true,
                           "buttonState": {
                               up: 'autoplay_btn_up.png',
                               out: 'autoplay_btn_up.png',
                               down: 'autoplay_btn_up.png',
                               disable: 'autoplay_btn_up.png',
                               enable: 'autoplay_btn_up.png',
                               hover: 'autoplay_btn_up.png'
                           },
                           "hitareaVisible": false,
                           "shapeVisible": false,
                           "shape": {}
                       },
                       {
                           "id": "singleWinLimitBtn2",
                           "name": "singleWinLimitBtn2",
                           "type": objectTypes.Sprite,
                           "interactive": false,
                           "uiMode": "desktop",
                           "layout": false,
                           "x": 800,
                           "y": 340,
                           "width": 107,
                           "height": 50,
                           "text": "option2",
                           "scaleToFit": true,
                           "textStyle": {
                               fontFamily: 'Oswald-Light',
                               fontSize: 24,
                               fontStyle: 'normal',
   
                               fill: ['#ffffff'],
                           },
                           "anchor": [0.5, 0.5],
                           "visible": true,
                           "buttonMode": true,
                           "buttonState": {
                               up: 'autoplay_btn_up.png',
                               out: 'autoplay_btn_up.png',
                               down: 'autoplay_btn_up.png',
                               disable: 'autoplay_btn_up.png',
                               enable: 'autoplay_btn_up.png',
                               hover: 'autoplay_btn_up.png'
                           },
                           "hitareaVisible": false,
                           "shapeVisible": false,
                           "shape": {}
                       },
                       {
                           "id": "singleWinLimitBtn3",
                           "name": "singleWinLimitBtn3",
                           "type": objectTypes.Sprite,
                           "interactive": true,
                           "uiMode": "desktop",
                           "layout": false,
                           "x": 950,
                           "y": 340,
                           "width": 107,
                           "height": 50,
                           "text": "option3",
                           "scaleToFit": true,
                           "textStyle": {
                               fontFamily: 'Oswald-Light',
                               fontSize: 24,
                               fontStyle: 'normal',
   
                               fill: ['#ffffff'],
                           },
                           "anchor": [0.5, 0.5],
                           "visible": true,
                           "buttonMode": true,
                           "buttonState": {
                               up: 'autoplay_btn_up.png',
                               out: 'autoplay_btn_up.png',
                               down: 'autoplay_btn_up.png',
                               disable: 'autoplay_btn_up.png',
                               enable: 'autoplay_btn_up.png',
                               hover: 'autoplay_btn_up.png'
                           },
                           "hitareaVisible": false,
                           "shapeVisible": false,
                           "shape": {}
                       },
                       {
                           "id": "singleWinLimitBtn4",
                           "name": "singleWinLimitBtn4",
                           "type": objectTypes.Sprite,
                           "interactive": true,
                           "uiMode": "desktop",
                           "layout": false,
                           "x": 1100,
                           "y": 340,
                           "width": 107,
                           "height": 50,
                           "text": "option4",
                           "scaleToFit": true,
                           "textStyle": {
                               fontFamily: 'Oswald-Light',
                               fontSize: 24,
                               fontStyle: 'normal',
   
                               fill: ['#ffffff'],
                           },
                           "anchor": [0.5, 0.5],
                           "visible": true,
                           "buttonMode": true,
                           "buttonState": {
                               up: 'autoplay_btn_up.png',
                               out: 'autoplay_btn_up.png',
                               down: 'autoplay_btn_up.png',
                               disable: 'autoplay_btn_up.png',
                               enable: 'autoplay_btn_up.png',
                               hover: 'autoplay_btn_up.png'
                           },
                           "hitareaVisible": false,
                           "shapeVisible": false,
                           "shape": {}
                       },
                       {
                           "id": "singleWinLimitBtn5",
                           "name": "singleWinLimitBtn5",
                           "type": objectTypes.Sprite,
                           "interactive": true,
                           "uiMode": "desktop",
                           "layout": false,
                           "x": 1250,
                           "y": 340,
                           "width": 107,
                           "height": 50,
                           "text": "option5",
                           "scaleToFit": true,
                           "textStyle": {
                               fontFamily: 'Oswald-Light',
                               fontSize: 24,
                               fontStyle: 'normal',
   
                               fill: ['#ffffff'],
                           },
                           "anchor": [0.5, 0.5],
                           "visible": true,
                           "buttonMode": true,
                           "buttonState": {
                               up: 'autoplay_btn_up.png',
                               out: 'autoplay_btn_up.png',
                               down: 'autoplay_btn_up.png',
                               disable: 'autoplay_btn_up.png',
                               enable: 'autoplay_btn_up.png',
                               hover: 'autoplay_btn_up.png'
                           },
                           "hitareaVisible": false,
                           "shapeVisible": false,
                           "shape": {}
                       },
                   ]
               },
    */
            /*         {
                        "id": "radioButtonOn",
                        "name": "radioButtonOn",
                        "type": objectTypes.Sprite,
                        "interactive": true,
                        "uiMode": "desktop",
                        "layout": false,
                        "width": 78,
                        "height": 44,
                        "x": 673,
                        "y": 400,
                        "text": "",
                        "anchor": [0.5, 0.5],
                        "visible": false,
                        "buttonMode": true,
                        "buttonState": {
                            up: 'raido_btn_on.png',
                            out: 'raido_btn_on.png',
                            down: 'raido_btn_on.png',
                            disable: 'raido_btn_on.png',
                            enable: 'raido_btn_on.png',
                            hover: 'raido_btn_on.png'
                        },
                        "hitareaVisible": false,
                        "shapeVisible": false,
                        "shape": {}
                    },
                    {
                        "id": "radioButtonOff",
                        "name": "radioButtonOff",
                        "type": objectTypes.Sprite,
                        "interactive": true,
                        "uiMode": "desktop",
                        "layout": false,
                        "width": 78,
                        "height": 44,
                        "x": 673,
                        "y": 400,
                        "text": "",
                        "anchor": [0.5, 0.5],
                        "visible": false,
                        "buttonMode": true,
                        "buttonState": {
                            up: 'raido_btn_off.png',
                            out: 'raido_btn_off.png',
                            down: 'raido_btn_off.png',
                            disable: 'raido_btn_off.png',
                            enable: 'raido_btn_off.png',
                            hover: 'raido_btn_off.png'
                        },
                        "hitareaVisible": false,
                        "shapeVisible": false,
                        "shape": {}
                    },
        
                    {
                        "id": "stopAutoplayText",
                        "name": "stopAutoplayText",
                        "type": "Text",
                        "uiMode": "desktop",
                        "layout": false,
                        "x": 513,
                        "y": 400,
                        "width": 400,
                        "height": 400,
                        "visible": false,
                        "text": "autoplayText_2",
                        "scaleToFit": true,
                        "anchor": [0.5, 0.5],
                        "textStyle": {
                            fontFamily: 'Oswald-Light',
                            fontSize: 36,
                            fill: '#ffffff',
                        },
                    },
                    {
                        "id": "onAnyWinText",
                        "name": "onAnyWinText",
                        "type": "Text",
                        "uiMode": "desktop",
                        "layout": false,
                        "x": 1300,
                        "y": 780,
                        "width": 400,
                        "height": 400,
                        "visible": true,
                        "text": "stopOnWinText",
                        "scaleToFit": true,
                        "anchor": [1, 0.5],
                        "textStyle": {
                            fontFamily: 'Oswald-Light',
                            fontSize: 22,
                            fontStyle: 'normal',
                            fill: ['#848484'],
                        },
                    },
        
                    {
                        "id": "radioButtonOnAnyWin",
                        "name": "radioButtonOnAnyWin",
                        "type": objectTypes.Sprite,
                        "interactive": true,
                        "uiMode": "desktop",
                        "layout": false,
                        "width": 38,
                        "height": 24,
                        "x": 1350,
                        "y": 780,
                        "text": "",
                        "anchor": [0.5, 0.5],
                        "visible": true,
                        "buttonMode": true,
                        "buttonState": {
                            up: 'autoplay_radio_btn_on.png',
                            out: 'autoplay_radio_btn_on.png',
                            down: 'autoplay_radio_btn_on.png',
                            disable: 'autoplay_radio_btn_on.png',
                            enable: 'autoplay_radio_btn_on.png',
                            hover: 'autoplay_radio_btn_on.png'
                        },
                        "hitareaVisible": false,
                        "shapeVisible": false,
                        "shape": {}
                    },
                    {
                        "id": "radioButtonOffOnAnyWin",
                        "name": "radioButtonOffOnAnyWin",
                        "type": objectTypes.Sprite,
                        "interactive": true,
                        "uiMode": "desktop",
                        "layout": false,
                        "width": 38,
                        "height": 24,
                        "x": 1350,
                        "y": 780,
                        "text": "",
                        "anchor": [0.5, 0.5],
                        "visible": true,
                        "buttonMode": true,
                        "buttonState": {
                            up: 'autoplay_radio_btn_off.png',
                            out: 'autoplay_radio_btn_off.png',
                            down: 'autoplay_radio_btn_off.png',
                            disable: 'autoplay_radio_btn_off.png',
                            enable: 'autoplay_radio_btn_off.png',
                            hover: 'autoplay_radio_btn_off.png'
                        },
                        "hitareaVisible": false,
                        "shapeVisible": false,
                        "shape": {}
                    },
        
                    {
                        "id": "onFeatureTriggeredText",
                        "name": "onFeatureTriggeredText",
                        "type": "Text",
                        "uiMode": "desktop",
                        "layout": false,
                        "x": 750,
                        "y": 780,
                        "width": 400,
                        "height": 400,
                        "visible": true,
                        "text": "stopfeaturetriggeredText",
                        "scaleToFit": true,
                        "anchor": [1, 0.5],
                        "textStyle": {
                            fontFamily: 'Oswald-Light',
                            fontSize: 22,
                            fontStyle: 'normal',
                            fill: ['#848484'],
                        },
                    },
        
                    {
                        "id": "radioButtonOnOnFeature",
                        "name": "radioButtonOnOnFeature",
                        "type": objectTypes.Sprite,
                        "interactive": true,
                        "uiMode": "desktop",
                        "layout": false,
                        "width": 38,
                        "height": 24,
                        "x": 800,
                        "y": 780,
                        "text": "",
                        "anchor": [0.5, 0.5],
                        "visible": true,
                        "buttonMode": true,
                        "buttonState": {
                            up: 'autoplay_radio_btn_on.png',
                            out: 'autoplay_radio_btn_on.png',
                            down: 'autoplay_radio_btn_on.png',
                            disable: 'autoplay_radio_btn_on.png',
                            enable: 'autoplay_radio_btn_on.png',
                            hover: 'autoplay_radio_btn_on.png'
                        },
                        "hitareaVisible": false,
                        "shapeVisible": false,
                        "shape": {}
                    },
                    {
                        "id": "radioButtonOffOnFeature",
                        "name": "radioButtonOffOnFeature",
                        "type": objectTypes.Sprite,
                        "interactive": true,
                        "uiMode": "desktop",
                        "layout": false,
                        "width": 38,
                        "height": 24,
                        "x": 800,
                        "y": 780,
                        "text": "",
                        "anchor": [0.5, 0.5],
                        "visible": true,
                        "buttonMode": true,
                        "buttonState": {
                            up: 'autoplay_radio_btn_off.png',
                            out: 'autoplay_radio_btn_off.png',
                            down: 'autoplay_radio_btn_off.png',
                            disable: 'autoplay_radio_btn_off.png',
                            enable: 'autoplay_radio_btn_off.png',
                            hover: 'autoplay_radio_btn_off.png'
                        },
                        "hitareaVisible": false,
                        "shapeVisible": false,
                        "shape": {}
                    },
        
        
                    {
                        "name": "inputBox_1",
                        "image": "meterImage",
                        "type": "Image",
                        "class": "",
                        "filterTypes": [],
                        "visible": false,
                        "width": 251,
                        "height": 67,
                        "x": 1230,
                        "y": 376
                    },
                    {
                        "name": "inputBox_2",
                        "image": "meterImage",
                        "type": "Image",
                        "class": "",
                        "filterTypes": [],
                        "visible": false,
                        "width": 251,
                        "height": 67,
                        "x": 1230,
                        "y": 494,
                    },
                    {
                        "name": "inputBox_3",
                        "image": "meterImage",
                        "type": "Image",
                        "class": "",
                        "filterTypes": [],
                        "visible": false,
                        "width": 251,
                        "height": 67,
                        "x": 1230,
                        "y": 612
                    }, */


            {
                "id": "sliderDot_2_inputBoxText",
                "name": "sliderDot_2_inputBoxText",
                "type": "Text",
                "x": 695,
                "y": 458,
                "width": 400,
                "height": 400,
                "visible": true,
                "text": "",
                "scaleToFit": true,
                "anchor": [0.5, 0.5],
                "textStyle": {
                    fontFamily: 'Oswald-Light',
                    fontSize: 24,

                    fill: '#ffffff',
                },
            },

            {
                "id": "sliderDot_3_inputBoxText",
                "name": "sliderDot_3_inputBoxText",
                "type": "Text",
                "x": 725,
                "y": 628,
                "width": 400,
                "height": 400,
                "visible": true,
                "text": "",
                "scaleToFit": true,
                "anchor": [0.5, 0.5],
                "textStyle": {
                    fontFamily: 'Oswald-Light',
                    fontSize: 24,

                    fill: '#ffffff',
                },
            },
            {
                "id": "sliderLineBG",
                "name": "sliderLineBG",
                "type": objectTypes.Sprite,
                "interactive": true,
                "width": 743,
                "height": 18,
                "x": 400,
                "y": 405,
                "text": "",
                "visible": false,
                "buttonMode": true,
                "buttonState": {
                    up: 'slider_base.png',
                    out: 'slider_base.png',
                    down: 'slider_base.png',
                    disable: 'slider_base.png',
                    enable: 'slider_base.png',
                    hover: 'slider_base.png'
                },
                "hitareaVisible": false,
                "shapeVisible": false,
                "shape": {}
            },
            {
                "id": "sliderDotLine",
                "name": "sliderDotLine",
                "type": objectTypes.Sprite,
                "interactive": true,
                "width": 743,
                "height": 18,
                "x": 400,
                "y": 405,
                "text": "",
                "visible": false,
                "buttonMode": true,
                "buttonState": {
                    up: 'slider_top.png',
                    out: 'slider_top.png',
                    down: 'slider_top.png',
                    disable: 'slider_top.png',
                    enable: 'slider_top.png',
                    hover: 'slider_top.png'
                },
                "hitareaVisible": false,
                "shapeVisible": false,
                "shape": {}
            },
            {
                "name": "sliderDot",
                "image": "sliderDot",
                "type": "Image",
                "class": "",
                "filterTypes": [],
                "visible": false,
                "width": 34,
                "height": 34,
                "x": 100,
                "y": 398
            },
            {
                "id": "sliderLine_2BG",
                "name": "sliderLine_2BG",
                "type": objectTypes.Sprite,
                "interactive": true,
                "width": 743,
                "height": 18,
                "x": 400,
                "y": 521,
                "text": "",
                "visible": false,
                "buttonMode": true,
                "buttonState": {
                    up: 'slider_base.png',
                    out: 'slider_base.png',
                    down: 'slider_base.png',
                    disable: 'slider_base.png',
                    enable: 'slider_base.png',
                    hover: 'slider_base.png'
                },
                "hitareaVisible": false,
                "shapeVisible": false,
                "shape": {}
            },
            {
                "id": "sliderDot_2Line",
                "name": "sliderDot_2Line",
                "type": objectTypes.Sprite,
                "interactive": true,
                "width": 743,
                "height": 18,
                "x": 400,
                "y": 521,
                "text": "",
                "visible": false,
                "buttonMode": true,
                "buttonState": {
                    up: 'slider_top.png',
                    out: 'slider_top.png',
                    down: 'slider_top.png',
                    disable: 'slider_top.png',
                    enable: 'slider_top.png',
                    hover: 'slider_top.png'
                },
                "hitareaVisible": false,
                "shapeVisible": false,
                "shape": {}
            },
            {
                "name": "sliderDot_2",
                "image": "sliderDot",
                "type": "Image",
                "class": "",
                "filterTypes": [],
                "visible": false,
                "width": 34,
                "height": 34,
                "x": 400,
                "y": 514
            },
            {
                "id": "sliderLine_3BG",
                "name": "sliderLine_3BG",
                "type": objectTypes.Sprite,
                "interactive": true,
                "width": 743,
                "height": 18,
                "x": 400,
                "y": 636,
                "text": "",
                "visible": false,
                "buttonMode": true,
                "buttonState": {
                    up: 'slider_base.png',
                    out: 'slider_base.png',
                    down: 'slider_base.png',
                    disable: 'slider_base.png',
                    enable: 'slider_base.png',
                    hover: 'slider_base.png'
                },
                "hitareaVisible": false,
                "shapeVisible": false,
                "shape": {}
            },

            {
                "id": "sliderDot_3Line",
                "name": "sliderDot_3Line",
                "type": objectTypes.Sprite,
                "interactive": true,
                "width": 743,
                "height": 18,
                "x": 400,
                "y": 636,
                "text": "",
                "visible": false,
                "buttonMode": true,
                "buttonState": {
                    up: 'slider_top.png',
                    out: 'slider_top.png',
                    down: 'slider_top.png',
                    disable: 'slider_top.png',
                    enable: 'slider_top.png',
                    hover: 'slider_top.png'
                },
                "hitareaVisible": false,
                "shapeVisible": false,
                "shape": {}
            },
            {
                "name": "sliderDot_3",
                "image": "sliderDot",
                "type": "Image",
                "class": "",
                "filterTypes": [],
                "visible": false,
                "width": 34,
                "height": 34,
                "x": 400,
                "y": 630
            },


            {
                "id": "ifSingleWinExceedText",
                "name": "ifSingleWinExceedText",
                "type": "Text",
                "x": 596,
                "y": 452,
                "width": 400,
                "height": 400,
                "visible": false,
                "text": "autoplayText_6",
                "scaleToFit": true,
                "anchor": [0.5, 0.5],
                "textStyle": {
                    fontFamily: 'Oswald-Light',
                    fontSize: 32,
                    fill: '#ffffff',
                },
            },
            {
                "id": "ifBalanceIncreaseByText",
                "name": "ifBalanceIncreaseByText",
                "type": "Text",
                "x": 601,
                "y": 571,
                "width": 400,
                "height": 400,
                "visible": false,
                "text": "autoplayText_7",
                "scaleToFit": true,
                "anchor": [0.5, 0.5],
                "textStyle": {
                    fontFamily: 'Oswald-Light',
                    fontSize: 32,
                    fill: '#ffffff',
                },
            },
            {
                "id": "ifBalanceDecreaseByText",
                "name": "ifBalanceDecreaseByText",
                "type": "Text",
                "x": 601,
                "y": 675,
                "width": 400,
                "height": 400,
                "visible": false,
                "text": "autoplayText_8",
                "scaleToFit": true,
                "anchor": [0.5, 0.5],
                "textStyle": {
                    fontFamily: 'Oswald-Light',
                    fontSize: 32,
                    fill: '#ffffff',
                },
            },
            {
                "id": "Button_1",
                "name": "autoplay_StartButton",
                "type": objectTypes.Sprite,
                "interactive": false,
                "x": 1684,
                "y": 909,
                "height": 80,
                "width": 80,
                "text": "",
                "visible": true,
                "buttonState": {
                    up: 'autoplay_down.png',
                    out: 'autoplay_down.png',
                    down: 'autoplay_down.png',
                    disable: 'autoplay_down.png',
                    enable: 'autoplay_down.png',
                    hover: 'autoplay_down.png'
                },
                "hitareaVisible": false,
                "shapeVisible": false,
                "shape": {}
            },
            {
                "id": "Button_2",
                "name": "autoplay_CancelButton",
                "type": objectTypes.Sprite,
                "interactive": true,
                "x": 1742,
                "y": 445,
                "width": 30,
                "height": 29,
                "text": "",
                "visible": true,
                "buttonMode": true,
                "buttonState": {
                    up: 'autoplay_closed_up.png',
                    out: 'autoplay_closed_up.png',
                    down: 'autoplay_closed_up.png',
                    disable: 'autoplay_closed_up.png',
                    enable: 'autoplay_closed_up.png',
                    hover: 'autoplay_closed_up.png'
                },
                "hitareaVisible": false,
                "shapeVisible": false,
                "shape": {}
            },
            {
                "id": "text_1",
                "name": "autoplay_text_start_label",
                "type": "Text",
                "x": 1055,
                "y": 778,
                "visible": false,
                "text": "autoplayText_20",
                "scaleToFit": true,
                "width": 210,
                "anchor": [0.5, 0.5],
                "textStyle": {
                    fontFamily: 'Oswald-Light',
                    fontSize: 26,

                    fill: ['#ffffff', '#ffffff', '#ffffff'],
                },
                "parentLayer": "specialAnimationLayer",
            },
            {
                "id": "text_2",
                "name": "autoplay_text_cancel_label",
                "type": "Text",
                "x": 866,
                "y": 778,
                "visible": false,
                "text": "autoplayText_21",
                "scaleToFit": true,
                "anchor": [0.5, 0.5],
                "textStyle": {
                    fontFamily: 'Oswald-Light',
                    fontSize: 26,

                    fill: ['#ffffff', '#ffffff', '#ffffff'],
                },
                "parentLayer": "specialAnimationLayer",
            },
        ],
    }
};

export const CanvasAutoplayConfigurationContext = React.createContext(
    {}
);